import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../../../../components/layout/Breadcrumb";
import { fetchMyTickets } from "../../../../redux/slice/supportSlice";

export default function TicketList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { tickets = [], loading, total } = useSelector(
    (state) => state.support
  );

  const [status, setStatus] = useState("");
  const [category, setCategory] = useState("all");

  const [page, setPage] = useState(0);
  const size = 10;

  // API call
  useEffect(() => {
    dispatch(fetchMyTickets({ status, page, size }));
  }, [dispatch, status, page, size]);

  // reset page when filter changes
  useEffect(() => {
    setPage(0);
  }, [status, category]);

  // navigation
  const handleNewTicket = () => {
    navigate("/admin/support/create-ticket");
  };

  const handleTicketDetails = (id) => {
    navigate(`/admin/support/view-ticket/${id}`);
  };

  /* ================= FORMAT ================= */
  const formatLabel = (value) => {
    if (!value) return "-";

    return value
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/,/g, ", ")
      .replace(/\s+/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // date format
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB");
  };

  // Category format
  const formatCategory = (value) => {
    if (!value) return "-";

    return value
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // filter tickets
  const filteredTickets = (tickets || []).filter((ticket) => {
    if (!ticket) return false;
    return category === "all" || ticket.category === category;
  });

  const totalPages = Math.ceil((total || 0) / size);

  return (

    <div className="container-fluid">
      <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: "18px" }}>
        <div className="icons-list">
          <Breadcrumb />
          <button className="primary-btn ml-4" type="button" onClick={handleNewTicket} >
            <i className="bi bi-plus-lg"></i>
            Create New Ticket
          </button>
        </div>
      </div>
      <div className="top-filter-section">
        <h6 style={{ fontWeight: 600, marginBottom: 12 }}>Filters: <em style={{ fontSize: 12, textTransform: "capitalize" }}>Filter the tickets list using the options below.</em></h6></div>
      {/* FILTERS */}
      <div className="filters-bar">

        <div className="filter-group">
          <div className="filter-icon">
            <i className="bi bi-grid"></i>
          </div>
          <select className="filter-select" value={category} onChange={(e) => setCategory(e.target.value)} >
            <option value="all">-- All Categories --</option>
            <option value="PROFILE_UPDATE">Profile Update</option>
            <option value="HARDWARE_ISSUE">Hardware</option>
            <option value="SOFTWARE_ISSUE">Software</option>
            <option value="PAYROLL_ISSUE">Payroll</option>
            <option value="OTHERS">Other</option>
          </select>
        </div>

        <div className="filter-group">
          <div className="filter-icon">
            <i className="bi bi-funnel"></i>
          </div>
          <select className="filter-select" value={status} onChange={(e) => setStatus(e.target.value)} >
            <option value="">-- All Status --</option>
            <option value="CREATED">Created</option>
            <option value="IN_PROGRESS">In Progress</option>
            <option value="RESOLVED">Resolved</option>
            <option value="APPROVED">Approved</option>
            <option value="UPDATED">Updated</option>
            <option value="REJECTED">Rejected</option>
            <option value="REWORK_REQUIRED">Rework Required</option>
            <option value="VERIFIED">Verified</option>
            <option value="ESCALATED">Escalated</option>
            <option value="CLOSED">Closed</option>
          </select>
        </div>
      </div>

      <div className="section-body m-0">
        <div className="container-fluid">
          <div className="card">
            <div className="tickets-page card-header">
              <div className="tickets-container card-body">
                {/* LIST */}
                <div className="tickets-list">
                  {loading && <p className="text-center">Loading Tickets...</p>}
                  {!loading && filteredTickets.length === 0 && (
                    <div className="no-tickets">
                      <p className="server-error-msg text-center">-- No tickets found --</p>
                    </div>
                  )}
                  {!loading &&
                    filteredTickets.map((ticket) => {
                      const statusClass = ticket?.status
                        ? ticket.status.toLowerCase().replace("_", "-")
                        : "unknown";

                      const priorityClass = ticket?.priority
                        ? ticket.priority.toLowerCase()
                        : "low";

                      return (
                        <div key={ticket.id} className={`ticket-card ${ticket.status === "RESOLVED" ? "resolved-card" : ""}`} >
                          <div className="ticket-info">
                            <div className="ticket-top-row">
                              <label className="fs-50 mb-0 text-secondary-dark font-weight-bold">Ticket ID:</label>
                              <span className="ticket-id">
                                #TKT-{ticket.id}
                              </span>

                              <div className="ticket-badges">
                                <span className={`badge status-badge status-${statusClass}`}>
                                  <em>Status:</em> {formatLabel(ticket.status || "-")}
                                </span>

                                <span className="priority-badge">
                                  <em>Priority: </em>
                                  <span className={`badge priority-${priorityClass}`} >
                                    {ticket.priority || "-"}
                                  </span>
                                </span>
                              </div>
                            </div>

                            <div className="mb-1">
                              <span className="fw-semibold text-secondary-dark me-2 fs-50">
                                Title:
                              </span>
                              <span className="text-dark meta-value">
                                {ticket.title || "-"}
                              </span>
                            </div>
                            <div className="mb-1">
                              <span className="fw-semibold text-secondary-dark me-2 fs-50">
                                Category:
                              </span>
                              <span className="text-dark meta-value">
                                <em>{formatLabel(ticket.category)}</em>
                              </span>
                            </div>

                            {ticket.category === "PROFILE_UPDATE" && (
                              <div className="mb-1">
                                <span className="fw-semibold text-secondary-dark me-2 fs-50">
                                  Sub Category:
                                </span>
                                <span className="text-dark meta-value">
                                  <em>{formatLabel(ticket.subCategories)}</em>
                                </span>
                              </div>
                            )}
                            <div className="mb-2">
                                  <span className="font-weight-bold text-secondary-dark me-2 fs-50">
                                    Description:
                                  </span>
                                  <span className="text-theme meta-value">
                                    {
                                      ticket.description?.length > 120
                                        ? `${ticket.description.slice(0, 120)}...`
                                        : ticket.description || "-"
                                    }
                                  </span>
                                </div>

                          </div>

                          <div className="ticket-action">
                            <span className="d-flex justify-content-end">
                              <button className="btn-view-details" onClick={() => handleTicketDetails(ticket.id)} >
                                <i className="bi bi-eye"></i>
                                View Details
                              </button>
                            </span>
                            <span className="ticket-date">
                              <em>Created at: </em> {formatDate(ticket.createdAt)}
                            </span>
                            <div className="mb-2">
                              <span className="fw-semibold text-secondary-dark me-2 fs-50">
                                Assignee name:
                              </span>
                              <span className="text-dark meta-value">
                                {ticket.assignedToName}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                </div>

                {/* PAGINATION */}
                {totalPages > 1 && (
                  <div className="pagination-container d-flex justify-content-center mt-3">
                    <button className="btn btn-light me-2 btn-left" disabled={page === 0} onClick={() => setPage(page - 1)} >
                      &laquo;
                    </button>
                    <span className="btn-number align-self-center">
                      {page + 1} of {totalPages}
                    </span>
                    <button className="btn btn-light ms-2 btn-right" disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)} >
                      &raquo;
                    </button>
                  </div>
                )}

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}